export enum RequestState {
    None,
    Waiting,
    Success,
    Error
}
